import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatToolbarModule, MatIconModule, MatButtonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  public userName: string = "";
  public userCode: string = "";
  public userType: string = "Vendor";
  ngOnInit() {
    let name = sessionStorage.getItem("user_name");
    let code = sessionStorage.getItem("user_code");
    let type = sessionStorage.getItem("userType");
    if (name && name.length > 0)
      this.userName = name;
    if (code && code.length > 0)
      this.userCode = code;
    if (type && type.length > 0)
      this.userType = type;
  }
}
